import { Box, Flex, Heading, Text, Image, Grid } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import logo from "../icons/b96594848721f785a06413e6adcbba-unscreen.gif"
import { useEffect } from 'react';
import ReactGA from 'react-ga';
const ChooseOptionPage = () => {
  const history = useNavigate();

  const handleOptionSelect = (option) => {
    ReactGA.event({
      category: 'Product Interaction',
      action: 'Product Clicked',
      label: option,
    });
    // Here you can navigate to the selected option page
    // For example, if the user selects 'mentors', navigate to '/mentors'
    history(`/${option}`);
  };
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [history]);

  return (
    <Flex direction="column" align="center" justify="center" paddingTop={"136px"} paddingBottom={"36px"} style={{ background: "linear-gradient(90deg, rgb(217 128 250) 0%, rgb(234 224 210) 100%)" }}
      paddingRight={"12px"} paddingLeft={"12px"} height={"100vh"}>
      <Box maxW="600px" w="100%" p={8} borderRadius="xl" bg="white" boxShadow="md">
        <Flex direction="column" align="center" mb={6}>
          {/* <Box display={"flex"} justifyContent={"center"}>
            <Image src={logo} alt="Logo" w={225} mb={0} />
          </Box> */}
          <Heading as="h1" size="xl" mb={4} color="gray.600" f >
            Choose who you want to talk to
          </Heading>
          <Text fontSize="xx-lg" color="gray.600" fontFamily={'Plus Jakarta Sans'} fontWeight={"700"}>
            Select from the options below to start your conversation:
          </Text>
        </Flex>
        <Grid templateColumns="repeat(1, 1fr)" gap={4} justifyContent={"center"}>
          <OptionCard
            title="Mentors"
            description="Connect with experienced mentors."
            imageSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRP6LTnq7ZDXDngFsvYI48nZVPQ_Os068Yatw&usqp=CAU"
            onClick={() => handleOptionSelect('mentors')}
          />
          <OptionCard
            title="Friends"
            description="Catch up with your friends."
            imageSrc="https://cdn-icons-png.flaticon.com/512/3429/3429193.png"
            onClick={() => handleOptionSelect('friends')}
          />
          <OptionCard
            title="Parents"
            description="Have a chat with your parents."
            imageSrc="https://cdn-icons-png.flaticon.com/512/7541/7541894.png"
            onClick={() => handleOptionSelect('parents')}
          />
          <OptionCard
            title="Loved Ones"
            description="Talk to your loved ones."
            imageSrc="https://cdn-icons-png.flaticon.com/512/6740/6740276.png"
            onClick={() => handleOptionSelect('loved-ones')}
          />
        </Grid>
      </Box>
    </Flex>
  );
};

const OptionCard = ({ title, description, imageSrc, onClick }) => {
  return (
    <Box p={4} borderWidth="1px" borderRadius="lg" boxShadow="md" cursor="pointer" onClick={onClick}>
      <Flex align="center">
        <Image src={imageSrc} alt={title} w="50px" h="50px" borderRadius="full" mr={4} />
        <Box>
          <Heading as="h3" color="black" size="md">{title}</Heading>
          <Text mt={1} color="gray.600">{description}</Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default ChooseOptionPage;